const actions = {
  PLAN_ADD_BEGIN: 'PLAN_ADD_BEGIN',
  PLAN_ADD_SUCCESS: 'PLAN_ADD_SUCCESS',
  PLAN_ADD_ERR: 'PLAN_ADD_ERR',
  
  PLANS_READ_BEGIN: 'PLANS_READ_BEGIN',
  PLANS_READ_SUCCESS: 'PLANS_READ_SUCCESS',
  PLANS_READ_ERR: 'PLANS_READ_ERR',

  PLAN_UPDATE_BEGIN: 'PLAN_UPDATE_BEGIN',
  PLAN_UPDATE_SUCCESS: 'PLAN_UPDATE_SUCCESS',
  PLAN_UPDATE_ERR: 'PLAN_UPDATE_ERR',

  PLAN_DELETE_BEGIN: 'PLAN_DELETE_BEGIN',
  PLAN_DELETE_SUCCESS: 'PLAN_DELETE_SUCCESS',
  PLAN_DELETE_ERR: 'PLAN_DELETE_ERR',

  PLAN_READ_BEGIN: 'PLAN_READ_BEGIN',
  PLAN_READ_SUCCESS: 'PLAN_READ_SUCCESS',
  PLAN_READ_ERR: 'PLAN_READ_ERR',

  PLAN_UPLOAD_BEGIN: 'PLAN_UPLOAD_BEGIN',
  PLAN_UPLOAD_SUCCESS: 'PLAN_UPLOAD_SUCCESS',
  PLAN_UPLOAD_ERR: 'PLAN_UPLOAD_ERR',

  axiosReadBegin: () => {
    return {
      type: actions.PLANS_READ_BEGIN,
    };
  },

  axiosReadSuccess: data => {
    return {
      type: actions.PLANS_READ_SUCCESS,
      data,
    };
  },

  axiosReadErr: err => {
    return {
      type: actions.PLANS_READ_ERR,
      err,
    };
  },

  axiosAddBegin: () => {
    return {
      type: actions.PLAN_ADD_BEGIN,
    };
  },

  axiosAddSuccess: data => {
    return {
      type: actions.PLAN_ADD_SUCCESS,
      data,
    };
  },

  axiosAddErr: err => {
    return {
      type: actions.PLAN_ADD_ERR,
      err,
    };
  },

  // Update

  axiosUpdateBegin: () => {
    return {
      type: actions.PLAN_UPDATE_BEGIN,
    };
  },

  axiosUpdateSuccess: data => {
    return {
      type: actions.PLAN_UPDATE_SUCCESS,
      data,
    };
  },

  axiosUpdateErr: err => {
    return {
      type: actions.PLAN_UPDATE_ERR,
      err,
    };
  },

  axiosDeleteBegin: () => {
    return {
      type: actions.PLAN_DELETE_BEGIN,
    };
  },

  axiosDeleteSuccess: data => {
    return {
      type: actions.PLAN_DELETE_SUCCESS,
      data,
    };
  },

  axiosDeleteErr: err => {
    return {
      type: actions.PLAN_DELETE_ERR,
      err,
    };
  },

  axiosSingleDataBegin: () => {
    return {
      type: actions.PLAN_READ_BEGIN,
    };
  },

  axiosSingleDataSuccess: data => {
    return {
      type: actions.PLAN_READ_SUCCESS,
      data,
    };
  },

  axiosSingleDataErr: err => {
    return {
      type: actions.PLAN_READ_ERR,
      err,
    };
  },

  axiosUploadBegin: () => {
    return {
      type: actions.PLAN_UPLOAD_BEGIN,
    };
  },

  axiosUploadSuccess: data => {
    return {
      type: actions.PLAN_UPLOAD_SUCCESS,
      data,
    };
  },

  axiosUploadErr: err => {
    return {
      type: actions.PLAN_UPLOAD_ERR,
      err,
    };
  },

};

export default actions;
